import {usaStates} from "~/util";
import moment from "moment";

export default {
	data: () => ({
		options: {
			booleans: ["Yes", "No"],
			transferCreditOptions: ["Yes", "No", "In Progress"],
			employmentTime: ["Full time", "Part time"],
			maritalStatuses: ["Single","Married",  "Divorced", "Widowed"],
			takenLocations: ["High School", "College", "Exam"],
			typesOfClasses: ["AP", "Dual Credit/Freshman Center"],
			classesTakenPrereq: ["Completed", "Currently taking","Scheduled to take"],
			classesTaken: ["Completed", "Currently taking","Scheduled to take", "Planning to take with Sara Schenirer"],
			howheard  :[
				"Alumni",

				"Career Forum Podcast",

				"College Advisor",

				"Eretz Yisroel Open House",

			"Friend/Family",

				"High School Visit",

				"Live-online Info Session",

				"Mentor",

				"Online Advertising",

				"Print Ads",

				"Seminary Visit",

				"Social Media",

				"Word-of-mouth",

				"Other"
			],
			colleges: [
				"Touro College",
				"Brooklyn College",
				"LIU",
				"FDU",
				"Queens",
				"TTI/Excelsior",
				"Charter Oak College",
				"Thomas Edison University",
				"Kingsboro College",
				"Bellevue University",
				"Elyon",
				"Maalot",
				"Mercy College",
				"Mt Saint Vincent/Sara Schenirer",
				"St Peter’s University/Sara Schenirer",
				"Concordia College / Sara Schenirer",
				"Other"
			],
			israelOptionPrograms :[

			"TTI",
            "Touro",
            "HTC"

			],
			israelOptionProgramsColleges :[

			"Daemen",
            		"Eastwick",
                    "Touro"  ,
                    "HTC" ,
                   "Stern College" ,
                    "Pillar College"


            			],
			typeOfExams: [
				"Straighterline",
				"CLEP",
				"ACE",
				"TAL",
				"Coopersmith",
				"DSST - DANTES",
				"Other"
			],
			levelExamVias: ["CLEP", "Coopersmith", "TAL"],
			months: [
				"01",
				"02",
				"03",
				"04",
				"05",
				"06",
				"07",
				"08",
				"09",
				"10",
				"11",
				"12"
			],
			years: [],
			usaStates: usaStates
		},
	}),

	beforeMount() {
		this.generateCreditCardYears();
	},

	methods: {
		generateCreditCardYears() {
			let currentYear = moment().year();
			let validYears = [];
			for (let index = currentYear; index <= currentYear + 20; index++) {
				validYears.push(index);
			}
			this.options.years = validYears;
		}
	}
}



// WEBPACK FOOTER //
// ./resources/js/mixins/options.js